import { ApplicationConfig, inject, PLATFORM_ID } from '@angular/core';
import { importProvidersFrom } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateStore, TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideState } from '@ngrx/store';
import { ColorThemeReducers } from '../store/color-theme/reducers';
import { ActiveLanguageReducers } from '../store/language/reducers';
import { provideEffects } from '@ngrx/effects';
import { JobsDataEffect } from '../store/jobs/effects';
import { provideAnimations } from '@angular/platform-browser/animations';


export const pageConfig: ApplicationConfig = {
  providers: [
    provideState("colorTheme", ColorThemeReducers),
    provideState("activeLanguage", ActiveLanguageReducers),
    provideEffects([JobsDataEffect]),
    importProvidersFrom(
      ReactiveFormsModule,
      TranslateModule.forChild({
        loader: {
          provide: TranslateLoader,
          useFactory: httpLoaderFactory,
          deps: [HttpClient],
        },
        isolate: true
      })),
    TranslateStore,
  ]
};

export function httpLoaderFactory(_http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(_http, './assets/i18n/page/page-', '.json');
}
